export default "__VITE_ASSET__c10043c3__"